<dialog part="dialog">
  {{#if not closeable}}
    <ui-icon link x class="close"></ui-icon>
  {{/if}}
  <div class="{{ui}}modal" part="modal">
    {{>slot}}
  </div>
</dialog>
